import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 2c4.687 0 8.5 3.813 8.5 8.5S14.187 19 9.5 19 1 15.187 1 10.5 4.813 2 9.5 2zm0-1C4.253 1 0 5.253 0 10.5S4.253 20 9.5 20s9.5-4.253 9.5-9.5S14.747 1 9.5 1z',
    'M8.917 5.984c-1.717.198-2.68 1.239-2.68 2.447 0 1.79 1.69 2.184 3.182 2.524 1.182.287 2.254.537 2.254 1.486 0 .859-.726 1.486-2.073 1.486-1.199 0-2.308-.573-2.89-1.235l-.709.967c.756.79 1.758 1.199 2.917 1.311l.083.014v1.531c0 .276.224.5.5.5s.5-.224.5-.5v-1.519l.083-.012c1.914-.173 2.917-1.25 2.917-2.578 0-1.916-1.763-2.346-3.291-2.686-1.145-.268-2.145-.502-2.145-1.325 0-.77.746-1.361 1.945-1.361 1.128 0 2.092.465 2.618 1.092l.638-.931c-.611-.602-1.499-1.074-2.681-1.199l-.083-.013v-1.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v1.489l-.083.011z',
  ],
  height: 20,
  width: 20,
});
